import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import GenericPromises from '../../../api/GenericPromises';
import { FormsErrors } from '../../../hooks/Forms/FormsErrors';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { Unit } from '../../../interfaces/Commons/units';
import { Header } from '../../../components/Header';
import { TextField } from '@mui/material';
import { ButtonStyled, PrimaryButton } from '../../../theme/buttons';
import { SnackbarComponent } from '../../../components/Commons/SnackBar';
import useSnackBar from '../../../components/Commons/SnackBar/useSnackBar';

export const AddUnits = () => {
    const [t] = useTranslation("global");
    const navigate = useNavigate();
    const { GenericPostResource, GenericGetResourceGeneric } = GenericPromises();
    const { showSnackBar, SnackbarComponent } = useSnackBar();
    const { GetError } = FormsErrors();
    const [loadingPost, setLoadingPost] = useState(false);

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<Unit>({
        defaultValues: {
            unit_code: '',
            unit_description: '',
            unit_symbol: '',
            international_unit_symbol: ''
        }
    });
    const onSubmit: SubmitHandler<Unit> = (data) => onPost(data);

    const onPost = (data: Unit) => {
        let myData = {
            unit_code: data.unit_code,
            unit_description: data.unit_description,
            unit_symbol: data.unit_symbol,
            international_unit_symbol: data.international_unit_symbol
        }
        setLoadingPost(true);
        GenericPostResource("/units", myData)
            .then((response) => {
                navigate("/units", { state: { method: "add" } });
            })
            .catch((error) => {
                setLoadingPost(false);
                showSnackBar(error.message, 'error');
            });
    }

    const onCancel = () => {
        // validacion si quiere cancelar sus cambios 
        navigate("/units", { state: {} });
    }

    useEffect(() => {
        GenericGetResourceGeneric("/companies", "/gcompanies").then((response) => {
            document.title = `${response.data.data[0].comercial_name} - ${t("units.title")}`;
        })
    }, [])

    return (
        <>
            <Header title={t("units.title-view")} />
            <div className='d-flex justify-content-center'>

                <div className='custom-card-view w-75'>

                    <form onSubmit={handleSubmit(onSubmit)} className='mt-4'>

                        <div className="custom-card-row d-flex justify-content-between">
                            <div className="w-100">
                                <div className='d-flex w-100'>
                                    <div className='w-50'>
                                        <Controller
                                            name="unit_code"
                                            control={control}
                                            rules={{ required: true, maxLength: 10 }}
                                            render={({ field }) =>
                                                <TextField
                                                    variant="filled"
                                                    label={`${t("units.fields.unit_code")}`}
                                                    ref={field.ref}
                                                    value={field.value}
                                                    onChange={(event) => { field.onChange(event.target.value) }}
                                                    error={!!errors.unit_code}
                                                    helperText={GetError(errors.unit_code?.type)}
                                                    size="small"
                                                    style={{ width: "100%" }}
                                                    sx={{ paddingRight: 2 }}
                                                />
                                            }
                                        />
                                    </div>
                                    <div className='w-50'>
                                        <Controller
                                            name="unit_description"
                                            control={control}
                                            rules={{ maxLength: 50 }}
                                            render={({ field }) =>
                                                <TextField
                                                    variant="filled"
                                                    label={`${t("units.fields.unit_description")}`}
                                                    ref={field.ref}
                                                    value={field.value}
                                                    onChange={(event) => { field.onChange(event.target.value) }}
                                                    error={!!errors.unit_description}
                                                    helperText={GetError(errors.unit_description?.type)}
                                                    size="small"
                                                    style={{ width: "100%" }}
                                                    sx={{ paddingRight: 2 }}
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                                <div className='d-flex w-100 mt-3'>
                                    <div className='w-50'>
                                        <Controller
                                            name="unit_symbol"
                                            control={control}
                                            rules={{ required: true, maxLength: 3 }}
                                            render={({ field }) =>
                                                <TextField
                                                    variant="filled"
                                                    label={`${t("units.fields.unit_symbol")}`}
                                                    ref={field.ref}
                                                    value={field.value}
                                                    onChange={(event) => { field.onChange(event.target.value) }}
                                                    error={!!errors.unit_symbol}
                                                    helperText={GetError(errors.unit_symbol?.type)}
                                                    size="small"
                                                    style={{ width: "100%" }}
                                                    sx={{ paddingRight: 2 }}
                                                />
                                            }
                                        />
                                    </div>
                                    <div className='w-50'>
                                        <Controller
                                            name="international_unit_symbol"
                                            control={control}
                                            rules={{ maxLength: 5 }}
                                            render={({ field }) =>
                                                <TextField
                                                    variant="filled"
                                                    label={`${t("units.fields.international_unit_symbol")}`}
                                                    ref={field.ref}
                                                    value={field.value}
                                                    onChange={(event) => { field.onChange(event.target.value) }}
                                                    error={!!errors.international_unit_symbol}
                                                    helperText={GetError(errors.international_unit_symbol?.type)}
                                                    size="small"
                                                    style={{ width: "100%" }}
                                                    sx={{ paddingRight: 2 }}
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='d-flex flex-row-reverse mt-1'>
                            <PrimaryButton type='submit' variant='outlined' className='m-1' disabled={loadingPost}>{t("generic.buttons.accept")}</PrimaryButton>
                            <ButtonStyled variant='contained' className='m-1' onClick={onCancel}>{t("generic.buttons.cancel")}</ButtonStyled>
                        </div>

                    </form>

                </div >

            </div >
            <SnackbarComponent />
        </>
    )
}
